import { jsx as o } from "react/jsx-runtime";
const l = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentcolor",
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m15.471 14.06-1.57 1.97c-2.83-1.35-4.48-2.9-5.89-5.83l1.95-1.66L8.651 3h-3.75c-1.05 0-1.932.851-1.875 1.899.467 8.569 7.492 15.594 16.049 16.075 1.062.06 1.926-.837 1.926-1.9V15.37z"
      }
    )
  }
);
export {
  l as default
};
